<template>
  <div id="banner">
    <div id="banner-wrapper">
      <img id="banner-image" src="./src/assets/banner.jpg" />
      <router-link :to="{ name: 'Symptoms' }">
        <div id="banner-main-text" class="noselect">FIX MY FOG</div>
      </router-link>
      <div id="banner-sub-text" class="noselect">SELECT YOUR SYMPTOMS, GET YOUR TREATMENT PLAN</div>
    </div>

    <router-view :key="$route.fullPath"></router-view>

    <div id="footer-container">
      <router-link :to="{ name: 'Symptoms' }">
        <div class="footer-container-link noselect">Home</div>
      </router-link>
      <router-link :to="{ name: 'FAQ' }">
        <div class="footer-container-link noselect">FAQ</div>
      </router-link>
      <router-link :to="{ name: 'PrivacyPolicy' }">
        <div class="footer-container-link">Privacy Policy</div>
      </router-link>
    </div>
  </div>
</template>

//
<script>
export default {
  name: "app",

  data() {
    return {};
  },
};
</script>

<style>
#banner {
  display: flex;
  flex-direction: column;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
}

body {
  margin: 0;
}

#banner-wrapper {
  position: relative;
}

#banner-image {
  max-height: 320px;
  width: 100%;
  margin: auto;
  display: block;
}

#banner-main-text {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 5.5em;
  color: white;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 900;
  letter-spacing: 0.25em;
}

#banner-main-text:before {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px;
  bottom: 0;
  left: 10%;
  border-bottom: 2px solid white;
}

#banner-sub-text {
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 0.95em;
  color: white;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 900;
  letter-spacing: 0.15em;
}

#footer-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 100%;
  background-color: #3f5060;
  margin-top: auto;
}

.footer-container-link {
  color: white;
  font-size: 0.9em;
  font-weight: 900;
  letter-spacing: 0.1em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 15px 0 15px;
}

/*///////////////////////////////////////////// Misc /////////////////////////////////////////////*/

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

a {
  text-decoration: none;
}

/*///////////////////////////////////////////// Media Queries /////////////////////////////////////////////*/

@media only screen and (max-width: 1920px) {
  #banner-image {
    max-height: 260px;
  }

  #banner-sub-text {
    top: 57%;
  }
}

@media only screen and (max-width: 1350px) {
  #banner-main-text {
    font-size: 4.5em;
  }
  #banner-sub-text {
    font-size: 0.8em;
    top: 55%;
  }
}

@media only screen and (max-width: 1200px) {
  #banner-main-text {
    font-size: 3.5em;
    width: 50%;
  }
  #banner-sub-text {
    font-size: 0.8em;
    top: 53%;
  }
}

@media only screen and (max-width: 900px) {
  #banner-image {
    max-height: 150px;
  }
  #banner-image {
    height: 150px;
  }
  #banner-main-text {
    font-size: 3em;
    width: 65%;
  }
  #banner-sub-text {
    font-size: 0.7em;
    width: 70%;
    top: 59%;
  }
}

@media only screen and (max-width: 600px) {
  #banner-image {
    max-height: 130px;
  }
  #banner-image {
    height: 150px;
  }
  #banner-main-text {
    font-size: 3em;
    width: 90%;
  }
  #banner-sub-text {
    font-size: 0.8em;
    width: 70%;
    top: 65%;
  }
}

@media only screen and (max-width: 406px) {
  #banner-image {
    max-height: 130px;
  }
  #banner-image {
    height: 150px;
  }
  #banner-main-text {
    font-size: 11vw;
    width: 90%;
  }
  #banner-sub-text {
    font-size: 3vw;
    width: 70%;
    top: 65%;
  }
}

/* @media only screen and (max-width: 330px) {
  #banner-image {
    max-height: 130px;
  }
  #banner-image {
    height: 150px;
  }
  #banner-main-text {
    font-size: 1.9em;
    width: 90%;
  }
  #banner-sub-text {
    font-size: 0.7em;
    width: 70%;
    top: 65%;
  }
} */
</style>
